import { breakpoints } from "../layout/breakpoints";
import { IBreakpoints } from "../theme.types";

export const getThemeBreakpoint = (key: keyof IBreakpoints): string =>
  `${breakpoints[key]}px`;
